export default "__VITE_ASSET__ab2e4301__";